import { Modal, CloseButton } from "react-bootstrap";
import { TextButton } from "Components/Button";

const ChatbotDisclaimerPopup = ({
  showDisclaimer,
  closeDisclaimer,
}) => {
  return (
    <>
      <Modal
        id="chatbot-disclaimer"
        size={"lg"}
        backdrop="static"
        keyboard={false}
        show={showDisclaimer}
        onHide={closeDisclaimer}
        scrollable={true}
      >
        <Modal.Header
          className="border-bottom-0 m-0 p-0 pe-3 pt-3"
        >
          <CloseButton className="align-self-start" onClick={closeDisclaimer}></CloseButton>
        </Modal.Header>
        <Modal.Body>
          <Modal.Title >PSOPPC Chatbot Disclaimer</Modal.Title>
          <div className="chatbot-disclaimer-body mx-3 mt-3">
            <div className="subtitle">Purpose and Scope</div>
            <p className="paragraph mt-2">
              The PSOPPC chatbot is powered by artificial intelligence (AI) and is designed to answer questions about
              AHRQ Common Formats, PSOPPC documentation, and PSOPPC systems.
              The chatbot is intended to provide information related to PSOPPC resources and AHRQ Common Formats.
              It is not intended to provide medical or legal advice, interpret patient-specific information, or
              replace assistance from PSOPPC Support.
            </p>
            <div className="subtitle">Information Accuracy</div>
            <p className="paragraph mt-2">
              The chatbot generates responses using PSOPPC and AHRQ-approved resources included in its knowledge base,
              such as Common Formats, Technical Specifications, Release Notes, and other official documentation.
            </p>
            <p className="paragraph">
              Although every effort is made to provide accurate and helpful information, chatbot responses may not always
              be complete, current, or applicable to your specific situation. Always verify important information by
              consulting the official documentation referenced in the chatbot response or available on the PSOPPC website.
            </p>
            <div className="subtitle">Quality Improvement</div>
            <p className="paragraph mt-2">
              User questions, interactions, and feedback may be reviewed by authorized PSOPPC staff to evaluate response
              quality, identify knowledge gaps, improve chatbot performance, and enhance the user experience.
              Information collected through the chatbot will not be used to train external AI models.
            </p>
            <div className="subtitle">Appropriate Use</div>
            <p className="paragraph mt-2">
              Chatbot responses are provided for informational purposes only and should not be considered official policy,
              legal advice, or a substitute for reviewing official PSOPPC and AHRQ documentation.
            </p>
            <p className="paragraph">
              Decisions regarding Common Formats implementation, technical requirements, or data submission should be based
              on official PSOPPC and AHRQ documentation. PSOPPC and its partners are not responsible for decisions or
              actions taken solely based on chatbot responses.
            </p>
            <div className="subtitle">Data Privacy</div>
            <p className="paragraph mt-2">
              Do not enter personal information, sensitive or confidential information, protected health information (PHI),
              or any information that could identify a patient, provider, healthcare facility, or other individual.
            </p>
            <div className="subtitle">Acknowledgement</div>
            <p className="paragraph mt-2">
              By continuing to use the chatbot, you acknowledge that you have read and understand this information.
              You may choose not to use the chatbot and instead review PSOPPC resources directly or contact PSOPPC Support.
            </p>
            <div className="subtitle">Support</div>
            <p className="paragraph mt-2">
              If you need additional assistance or have questions that cannot be answered by the chatbot, please contact
              PSOPPC Support at <a href="mailto:support@psoppc.org">support@psoppc.org</a> or (866) 571-7712, Monday through Friday, 9:00 AM–5:30 PM ET.
            </p>
            <p className="paragraph">
              You may also visit the Get Help page on the PSOPPC website.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <TextButton
            variant="normal"
            onClick={closeDisclaimer}
            content={"Close"}
          >
          </TextButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ChatbotDisclaimerPopup;